import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_otp) return data;
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password, name, acceptTerms) => {
    const { data } = await api.post("/auth/signup", { email, password, name, accept_terms: !!acceptTerms });
    if (data.requires_otp) return data;
    setUser(data.user);
    return data.user;
  };

  const verifyOtp = async (email, code, rememberDevice) => {
    const { data } = await api.post("/auth/verify-otp", { email, code, remember_device: !!rememberDevice });
    setUser(data.user);
    return data.user;
  };

  const resendOtp = (email) => api.post("/auth/resend-otp", { email });

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/browse";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.debug("logout request failed (ignored):", err?.message);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, login, signup, verifyOtp, resendOtp, loginWithGoogle, logout, refresh: checkAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
};
